import { render, staticRenderFns } from "./CorporationInfoTab1.vue?vue&type=template&id=02b0d83c"
import script from "./CorporationInfoTab1.vue?vue&type=script&lang=js"
export * from "./CorporationInfoTab1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02b0d83c')) {
      api.createRecord('02b0d83c', component.options)
    } else {
      api.reload('02b0d83c', component.options)
    }
    module.hot.accept("./CorporationInfoTab1.vue?vue&type=template&id=02b0d83c", function () {
      api.rerender('02b0d83c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/CorporationInfoTab1.vue"
export default component.exports